import * as components from './components';

export default [
  {
    path: '/masters/customer-chains',
    component: components.CustomerChainList,
    name: 'customerChainList',
    meta: { admin: true }
  }
];


// WEBPACK FOOTER //
// ./ClientApp/app/masters/customerchains/routes.js